module.exports = __webpack_public_path__ + "img/icon_star_outline.e4dd5e30.svg";